module.exports = __webpack_public_path__ + "img/saoma.07b8d240.png";